import render from './render'

export default {
  name: 'TasksItem',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      menuIsShowed: false
    }
  },

  render
}
